import type { EditorHost } from '@blocksuite/block-std';
import type { AffineAIPanelWidgetConfig, EdgelessRootService } from '@blocksuite/blocks';
import { Bound, getCommonBound } from '@blocksuite/global/utils';
import { nothing } from 'lit';

import { PPTBuilder } from '../slides/index';

export const createSlidesDataProcessor: (
  host: EditorHost,
  ctx: {
    get: () => Record<string, unknown>;
    set: (data: Record<string, unknown>) => void;
  }
) => AffineAIPanelWidgetConfig['answerRenderer'] = (host, ctx) => {
  return (answer, state) => {
    if (state === 'finished' || state === 'error') {
      // Process slides data for edgeless-response.ts handler
      PPTBuilder(host)
        .process(answer)
        .then(res => {
          ctx.set({
            contents: res.contents,
            images: res.images,
            bounds: res.bounds,
          });

          const bounds = Array.isArray(res.bounds) ? res.bounds : [];
          if (!bounds.length) return;

          const service = host.spec.getService<EdgelessRootService>('affine:page');
          if (!service) return;

          const focus = () => {
            const boundInstances = bounds
              .filter(bound =>
                bound &&
                typeof bound.x === 'number' &&
                typeof bound.y === 'number' &&
                typeof bound.w === 'number' &&
                typeof bound.h === 'number'
              )
              .map(({ x, y, w, h }) => new Bound(x, y, w, h));

            if (!boundInstances.length) {
              return false;
            }

            const combined = getCommonBound(boundInstances);
            if (!combined) {
              return false;
            }

            service.viewport.setViewportByBound(combined, [100, 100, 100, 100], true);
            return true;
          };

          if (!focus()) {
            setTimeout(() => {
              focus();
            }, 120);
          }
        })
        .catch(console.error);
    }
    return nothing;
  };
};
